export default __webpack_public_path__ + "static/media/Snd_TryS.2260707a.mp3";